import { CalendarDay } from "~/shared.types";

export const isLastDayOfMonthVisible = (
  container: HTMLDivElement,
  days: CalendarDay[],
) => {
  const lastDay = days.find(
    (d) =>
      d.date.getMonth() === days[0].date.getMonth() &&
      d.date.getFullYear() === days[0].date.getFullYear() &&
      d.date.getDate() ===
        new Date(d.date.getFullYear(), d.date.getMonth() + 1, 0).getDate(),
  );
  if (!lastDay) return false;
  const el = container.querySelector(
    `[data-date="${lastDay.date.toISOString()}"]`,
  ) as HTMLElement;
  if (!el) return false;
  const { scrollLeft, clientWidth } = container;
  const left = el.offsetLeft;
  const right = left + el.offsetWidth;
  return left >= scrollLeft && right <= scrollLeft + clientWidth;
};
